import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";

import Text from '../../components/Text';
import Button from '../../components/Button';
import { retryAction } from './actions';
import { setError, clearStreamVod } from '../../redux-root/actions';
import gtmHelper from '../../utils/gtmHelper';

import styles from './index.module.css';

import alertIcon from '../../assets/icons/error/alert.svg';

function ErrorPage(props) {
  const { error, streamVod, hashUserId, networkMode } = props;

  const [retryMode, setRetryMode] = useState(true);

  const navigateTo = useNavigate();

  const data = error && error.obj ? error.obj.data : '';

  let errorImage = alertIcon;
  let errorTitle = error && error.title ? error.title : '';
  let errorMessage = error && error.message ? error.message : '';

  if (networkMode) {
    errorTitle = 'No internet connection';
    errorMessage = 'Check that your device is connected to an available network.';
  }

  useEffect(() => {
    document.addEventListener('keydown', changeFocus);
    document.getElementById('error-0').focus();

    if (error && error.title !== 'General Errors') {
      setRetryMode(false);
    }

    if (!networkMode) {
      gtmHelper({
        category: 'watchcast-error',
        section: errorTitle,
        subSection: data && data.title ? data.title : '',
        action: 'error-prompt-load',
        label: 'error-prompt-load',
        userId: hashUserId ? hashUserId : '',
        errorName: data && data.status ? data.status : '',
        componentType: 'error-prompt-load'
      });
    }

    return () => {
      document.removeEventListener("keydown", changeFocus);
    };
    /* eslint-disable */
  }, []);

  const errorClick = () => {
    gtmHelper({
      category: 'watchcast-error',
      section: errorTitle,
      subSection: data && data.title ? data.title : '',
      action: 'button-click',
      label: retryMode ? 'retry' : 'back',
      userId: hashUserId ? hashUserId : '',
      errorName: data && data.status ? data.status : '',
      componentType: 'error-prompt'
    });

    if (retryMode) {
      props.retryAction();
    } else {
      navigateTo(-1);
      props.setError(null);
    }
  }

  const changeFocus = (e) => {
    if (e.keyCode === 10009 || e.keyCode === 461) { // BACK KEY TIZEN & LG
      if (streamVod) {
        props.clearStreamVod();
      } else {
        navigateTo(-1);
      }
      
      props.setError(null);
    }
  };

  return (
    <div className={styles['wrapper']}>
      <div className={styles['page']}>
        <img src={errorImage} className={styles['icon']} alt="alert-icon" />
        <Text className={styles['header']} type="h4">
          {errorTitle}
        </Text>
        <Text className={styles['description']} type="l32">
          {errorMessage}
        </Text>

        <Button text={retryMode ? "Retry" : "Back"} textType="lb28" onClick={errorClick} id="error-0" style={{ minWidth: '240px' }} />
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  error: state.app.error,
  streamVod: state.app.streamVod,
  hashUserId: state.app.hashUserId
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      retryAction,
      setError,
      clearStreamVod
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
